[
  {
    "code": "MZ-P",
    "name": "Cabo Delgado"
  },
  {
    "code": "MZ-G",
    "name": "Gaza"
  },
  {
    "code": "MZ-I",
    "name": "Inhambane"
  },
  {
    "code": "MZ-B",
    "name": "Manica"
  },
  {
    "code": "MZ-L",
    "name": "Maputo"
  },
  {
    "code": "MZ-N",
    "name": "Nampula"
  },
  {
    "code": "MZ-A",
    "name": "Niassa"
  },
  {
    "code": "MZ-S",
    "name": "Sofala"
  },
  {
    "code": "MZ-T",
    "name": "Tete"
  },
  {
    "code": "MZ-Q",
    "name": "Zambézia"
  }
]